import {Component, OnInit, HostListener, OnDestroy} from '@angular/core';
import {PhoneTransformer} from '../../../services/transformer.service';
import {PropertyService} from './services/property.service';
import {Property} from '../../../types/admin-data.types';
import {UrlService} from '../../../services/url.service';
import {flatMap, takeUntil, tap} from 'rxjs/operators';

@Component({
    templateUrl: './property.component.html',
    styleUrls: ['./property.component.scss']
})
export class PropertyComponent implements OnInit, OnDestroy {
    currentTabId: string;
    spinnerShow = false;
    tabTitles = {
        property: 'Property',
        propertyGroup: 'Corporation'
    };

    constructor(public propertyService: PropertyService,
                public urlService: UrlService
    ) {
    }

    ngOnInit() {
        this.propertyService.getBuildings();
        this.propertyService.getBuildingFolders();
        this.propertyService.getListCustomThemes();
        this.urlService.getQueryParams();
        this.urlService.onUrlChange
            .pipe(
                tap(
                    () => {
                        this.propertyService.viewedItem = null;
                        this.propertyService.isShowView = false;
                        this.propertyService.selectedItemData = null;
                        this.propertyService.currentTabId = this.currentTabId = this.urlService.queryParams['tab'];
                        if (this.propertyService.currentTabId == 'propertyGroup')
                            this.urlService.queryParams['company_id'] = [];
                    }
                ),
                flatMap(() => this.propertyService.getByQueryParams().pipe(takeUntil(this.urlService.instantOnUrlChange)))
            )
            .subscribe();
        this.propertyService.getServices();
        this.propertyService.getCorporationNumberList();
        if (this.propertyService.timezoneList.length === 0)
            this.propertyService.getTimezoneList();

        let tabId = this.urlService.queryParams.tab || 'property';
        if (!this.propertyService.propertyData[tabId]) tabId = 'property';
        this.urlService.setQueryParams(tabId);
    }


    removeItem(item, event) {
        event.stopPropagation();
        this.propertyService.remove(item.id).subscribe(() => {
            this.closeDetails();
        });
    }

    toggleDetails(item: Property): void {
        this.propertyService.isShowView = this.propertyService.toggleCheck(item);
        if (this.propertyService.isShowView) {
            this.propertyService.viewedItem = item;
            this.propertyService.getBuildingInfo();
            this.propertyService.getCurrentServices(
                this.propertyService.viewedItem.id
            );
        }
    }

    closeDetails(): void {
        if (this.propertyService.viewedItem) {
            this.propertyService.viewedItem.checked = false;
        }

        this.propertyService.isShowView = false;
        this.urlService.modalClosed.emit();
    }

    createNew(): void {
        const queryParams = this.urlService.getQueryParamsString();
        const tabId = this.urlService.queryParams['tab'];
        if (tabId == 'propertyGroup') {
            this.propertyService.selectedBuildings = [];
            this.propertyService.currentCorporationNumber = '';
        }
        this.propertyService.isCreateNew = true;
    }

    closeCreateNew(): void {
        this.propertyService.isCreateNew = false;
    }

    closeEdit(): void {
        this.propertyService.isEditShow = false;
    }

    @HostListener('window:resize', ['$event'])
    onResize() {
        this.propertyService.emptyRowService.fillEmptyRow();
    }

    formatPhone(phone: string) {
        return PhoneTransformer.stringToPhone(phone);
    }

    ngOnDestroy() {
        this.removeAllObservers();
        this.propertyService.urlService.resetQueryParams();
        this.propertyService.data = [];
        this.propertyService.isShowView = false;
    }

    removeAllObservers() {
        this.propertyService.urlService.onUrlChange.observers = [];
    }

    getActiveTabTitle() {
        const tabId = this.urlService.queryParams['tab'];
        return this.tabTitles[tabId];
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/admin/property/property.component.ts